var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 5H18.334V15.833H1.66797V5H5.20898L6.25098 2.5H13.751L14.793 5ZM6.04297 6.25H2.91797V14.583H17.084V6.25H13.959L12.918 3.75H7.08398L6.04297 6.25ZM10.001 6.66699C11.8426 6.66699 13.334 8.15833 13.334 10C13.334 11.8417 11.8426 13.333 10.001 13.333C8.15931 13.333 6.66797 11.8417 6.66797 10C6.66797 8.15833 8.15931 6.66699 10.001 6.66699ZM10.001 7.91699C8.85098 7.91699 7.91797 8.85 7.91797 10C7.91797 11.15 8.85098 12.083 10.001 12.083C11.151 12.083 12.084 11.15 12.084 10C12.084 8.85 11.151 7.91699 10.001 7.91699Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Camera_icon.670b8e3400eeb02f144c9b5e2a84da1e.svg";